
















import { Component, Vue, Prop } from "vue-property-decorator";
import LabelRepositorySearch from '@/components/MaterialLabel/LabelRepositorySearch.vue';
import HelpContent from '@/components/HelpContent.vue';

@Component({
    components: {
        LabelRepositorySearch,
        HelpContent
    }
  })
  export default class LabelRepositoryPage extends Vue {


  }
